var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"kontainer"},[_c('h1',[_vm._v("mein Profil")]),_c('p',[_vm._v(_vm._s(_vm.userSelbst))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }